// import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Tag, Popconfirm } from "antd";
import { useState } from "react";
import formatter from "../../utils/formatter";
import QuantityModal from "../../components/modals/QuantityModal";
// import formatter from "../../utils/formatter";

const ListingView = ({
  product,
  type,
  deactivateItem,
  editItem,
  deleteItem,
  deleteDraft,
  productTag,
  flagged,
}) => {
  const [showQtyModal, setShowQtyModal] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);

  const history = useHistory();

  const Status = () => {
    const status = product?.status?.toLowerCase();
    let color = "success";

    if (status === "pending approval") color = "warning";
    if (status === "rejected") color = "error";
    if (status === "deactivated") color = "magenta";
    return (
      <Tag color={color} className="txt-product-status">
        {status}
      </Tag>
    );
  };

  return (
    <div className="manage-listings-body-content-listing-item-container">
      <div className="manage-listings-body-content-listing-item">
        {type === "draft" ? (
          <>
            {/* {product.image1 ? ( */}
            <div
              className="manage-listings-body-content-listing-item-image"
              style={{ backgroundImage: `url(${product.image1})` }}
            >
              {productTag && (
                <div className="manage-listings-product-tag">{productTag}</div>
              )}
            </div>
            {/* ) : ( */}
            {/* <div
                className="manage-listings-body-content-listing-item-image"
                style={{ backgroundImage: `url("/images/draft_bg.jpeg")` }}
              /> */}
            {/* )} */}
          </>
        ) : (
          <>
            {/* {product.img1 ? ( */}
            <div
              className="manage-listings-body-content-listing-item-image"
              style={{
                backgroundImage: `url(${product?.img1 || product?.image1})`,
                cursor: "pointer",
              }}
              onClick={() => history.push(`/listing/${product?.product_id}`)}
            >
              {productTag && (
                <div className="manage-listings-product-tag">{productTag}</div>
              )}
            </div>
            {/* ) : ( */}
            {/* <div
                className="manage-listings-body-content-listing-item-image"
                style={{ backgroundImage: `url("/images/draft_bg.jpeg")` }}
              /> */}
            {/* )} */}
          </>
        )}
        <div>
          <div className="manage-listings-body-content-listing-item-text">
            <div
              className="manage-listings-body-content-listing-item-designer"
              // onClick={() =>
              //   history.push(`/seller/${.slug}/info`, record)
              // }
            >
              {product?.brand_name}

              <div
                style={{
                  fontSize: "10px",
                  color: "#6f6f6f",
                  fontWeight: "normal",
                }}
              >
                Item ID: {product?.product_id}
              </div>
            </div>
            <div className="manage-listings-body-content-listing-item-title">
              {product?.name
                ? product.name.toLowerCase().slice(0, 50) + "..."
                : "Untitled Listing"}
            </div>
            <div className="manage-listings-body-content-listing-item-subtitle">
              {product?.price != null &&
              product?.price !== "" &&
              !isNaN(product?.price)
                ? formatter(product.price)
                : "Price not set"}
            </div>
            <div className="manage-listings-body-content-listing-item-date">
              Created {product?.created_at}
            </div>
            <div className="manage-listings-body-content-listing-item-tag">
              <Status />

              {flagged && (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15Z"
                    fill="#800000"
                    stroke="#800000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 22V15"
                    stroke="#800000"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              )}
            </div>
          </div>

          <div className="manage-listings-body-content-listing-item-action-container">
            <svg
              onClick={() => setOpenSettings(!openSettings)}
              width="22"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.2657 20H8.67463L7.91343 19.1463L7.61493 17.3313C7.31642 17.2149 6.77015 17.009 6.35821 16.806L4.97612 17.9104L3.82388 17.9761L1.99104 16.1343L2.05672 14.994L3.1194 13.5015C2.92173 13.1181 2.75696 12.7187 2.62687 12.3075L0.853731 12.009L0 11.2657V8.67463L0.853731 7.91343L2.64478 7.61493C2.77909 7.2039 2.94681 6.80456 3.14627 6.4209L2.08955 4.96716L2.02388 3.82388L3.8806 1.99104L5.02388 2.05672L6.51642 3.12239C6.90448 2.94328 7.41194 2.76418 7.71045 2.66269L7.98806 0.871642L8.73433 0H11.3254L12.0866 0.853731L12.3851 2.64478C12.7966 2.77766 13.1961 2.94544 13.5791 3.14627L15.0328 2.08955L16.1761 2.02388L18.009 3.8806L17.9433 5.02388L16.8806 6.51642C17.0783 6.89977 17.243 7.29922 17.3731 7.71045L19.1463 7.99403L20 8.73433V11.3254L19.1463 12.0866L17.3313 12.3851C17.2209 12.6836 17.0328 13.1851 16.8418 13.5791L17.9104 15.0328L17.9761 16.1761L16.1433 18.009L15 17.9433L13.5075 16.8806C13.1453 17.0662 12.769 17.223 12.3821 17.3493L12.0179 19.1403L11.2657 20ZM9.07463 19.1045H10.8657L11.191 18.7373L11.6119 16.6478L11.8746 16.5701C12.3807 16.428 12.8685 16.2277 13.3284 15.9731L13.5761 15.8358L15.3015 17.0746L15.7851 17.1015L17.0507 15.8209L17.0149 15.3463L15.7851 13.6418L15.9284 13.391C16.1783 12.8885 16.3947 12.37 16.5761 11.8388L16.6627 11.5881L18.7522 11.2448L19.1045 10.9254V9.13433L18.7463 8.81493L16.6567 8.48358L16.5821 8.20298C16.436 7.66902 16.2255 7.1548 15.9552 6.67164L15.8209 6.42388L17.0597 4.69851L17.0866 4.21493L15.8209 2.95224L15.3463 2.98507L13.6358 4.21791L13.3851 4.07463C12.9067 3.80017 12.3964 3.58563 11.8657 3.43582L11.591 3.35821L11.2448 1.26866L10.9254 0.895522H9.13433L8.81493 1.25373L8.49254 3.34328L8.22985 3.42687C7.69698 3.58877 7.17627 3.78828 6.67164 4.02388L6.42388 4.16119L4.69851 2.93731L4.21493 2.90746L2.94925 4.1791L2.9791 4.6597L4.21493 6.36418L4.07164 6.61492C3.79496 7.09464 3.57935 7.60707 3.42985 8.1403L3.35224 8.41493L1.26269 8.76119L0.895522 9.07463V10.8657L1.25373 11.1851L3.34328 11.5164L3.41791 11.797C3.56403 12.331 3.77453 12.8452 4.04478 13.3284L4.18209 13.5761L2.93433 15.3015L2.90746 15.7851L4.1791 17.0507L4.64179 17.0149L6.26866 15.7313L6.53134 15.8866C7.05641 16.1551 7.6001 16.3855 8.15821 16.5761L8.40597 16.6657L8.74925 18.7552L9.07463 19.1045Z"
                fill="#010101"
              />
              <path
                d="M8.46857 14.4358L5.97006 12.4149L5.37305 9.25375L6.93126 6.44778L9.91633 5.30151L12.9492 6.34629L14.5999 9.09853L14.1014 12.2776L11.6775 14.3672L8.46857 14.4358ZM7.34021 11.597L8.98797 12.9344L11.1104 12.8985L12.7133 11.5075L13.0477 9.41793L11.9551 7.60002L9.94917 6.90748L7.96409 7.66569L6.93424 9.52241L7.34021 11.597Z"
                fill="#6B1214"
              />
            </svg>
          </div>
        </div>
        <div
          className="manage-listings-body-content-listing-item-extra"
          style={{ display: openSettings ? "block" : "none" }}
        >
          {type !== "draft" && (
            <div className="" onClick={() => setOpenSettings(!openSettings)}>
              <div
                className="manage-listings-body-content-listing-item-extra-item"
                onClick={editItem}
              >
                Edit
              </div>
              {/* <div
                className="manage-listings-body-content-listing-item-extra-item"
                // onClick={copyItem}
              >
                Copy
              </div> */}
              {product?.status &&
                !["Pending Approval", "Deactivated"].includes(
                  product.status
                ) && (
                  <div
                    className="manage-listings-body-content-listing-item-extra-item"
                    onClick={deactivateItem}
                  >
                    Deactivate
                  </div>
                )}
              <div
                className="manage-listings-body-content-listing-item-extra-item"
                onClick={() => setShowQtyModal(true)}
              >
                Edit Size / Quantity
              </div>
            </div>
          )}
          {type === "draft" && (
            <div>
              <div
              // onClick={onResume}
              >
                Complete Listing
              </div>
            </div>
          )}
          <Popconfirm
            placement="topLeft"
            title="Are you sure you want to delete this listing?"
            onConfirm={type === "draft" ? deleteDraft : deleteItem}
            okText="Yes"
            cancelText="No"
          >
            <div
              style={{
                borderTop: "1px solid #d4d4d4",
                padding: "10px 20px",
              }}
              className="manage-listings-body-content-listing-item-extra-item"
            >
              Delete
            </div>
          </Popconfirm>
        </div>
      </div>

      <QuantityModal
        visible={showQtyModal}
        setVisible={setShowQtyModal}
        product={product}
      />

      <style jsx="true">
        {`
          .manage-listings-body-content-listing-item-container {
            width: 25%;
            margin-bottom: 24px;
            padding: 0 5px;
          }
          .manage-listings-body-content-listing-item {
            border: 1px solid #d4d4d4;
            position: relative;
            height: fit-content;
          }
          .manage-listings-body-content-listing-item-image {
            width: 100%;
            height: 250px;
            background-size: cover;
            background-position: top;
            background-repeat: no-repeat;
          }
          .manage-listings-body-content-listing-item-text {
            padding: 10px;
            display: flex;
            flex-direction: column;
            // height: ${type === "draft" ? "50px" : "120px"};
            justify-content: space-between;
            font-size: 12px;
            gap: 12px;
          }
          .manage-listings-body-content-listing-item-title {
            height: 45px;
            font-size: 14px;
            overflow-wrap: break-word;
            text-transform: capitalize;
          }
          .manage-listings-body-content-listing-item-designer {
            font-size: 16px;
            font-weight: bold;
            overflow-wrap: break-word;
            font-family: "DomaineSansText-Regular";
            text-transform: capitalize;
          }
          .manage-listings-body-content-listing-item-subtitle {
            font-family: "DomaineSansText-Regular";
          }
          .manage-listings-body-content-listing-item-action-container {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 20px;
            padding: 10px;
            border-top: 1px solid #d4d4d4;
            margin-top: 4px;
          }
          .manage-listings-body-content-listing-item-action-container * {
            cursor: pointer;
          }
          .manage-listings-body-content-listing-item-action-container *:hover {
            color: #800000;
          }

          .manage-listings-body-content-listing-item-extra {
            position: absolute;
            width: 100%;
            z-index: 20;
            background: white;
            padding: 10px 0;
            border: 1px solid #d4d4d4;
          }
          .manage-listings-body-content-listing-item-extra div {
            padding: 10px;
            cursor: pointer;
          }
          .manage-listings-body-content-listing-item-extra-item:hover {
            color: #800000;
          }
          .txt-product-status {
            text-transform: capitalize;
          }
          .manage-listings-product-tag {
            color: white;
            background-color: #800000;
            width: fit-content;
            padding: 4px 8px;
            font-size: 12px;
          }
          .manage-listings-body-content-listing-item-tag {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          @media (max-width: 640px) {
            .manage-listings-body-content-listing-item-container {
              width: auto;
              margin-bottom: 24px;
              padding: 0 5px;
            }
            .manage-listings-body-content-listing-item {
              border: 0;
              display: flex;
              height: auto;
              justify-content: center;
            }
            .manage-listings-body-content-listing-item-image {
              width: 200px;
              height: auto;
            }
            .manage-listings-body-content-listing-item-text {
              width: clamp(160px, 42vw, 335px);
            }
            .manage-listings-body-content-listing-item-action-container {
              margin: 4px 10px 0;
            }
            .manage-listings-body-content-listing-item-extra {
              top: 220px;
            }
            .manage-listings-body-content-listing-item-text {
              min-height: 174px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ListingView;
